// ../../components/shared/Badges/PriceTag.tsx
export default function PriceTag({
  label,
  value,
  tone = "orange",
}: {
  label: string;
  value: number;
  tone?: "orange" | "green" | "gray" | "red";
}) {
  const toneMap = {
    orange: "bg-orange-50 text-orange-700 ring-orange-200",
    green: "bg-green-50 text-green-700 ring-green-200",
    gray: "bg-gray-50 text-gray-700 ring-gray-200",
    red: "bg-red-50 text-red-700 ring-red-200",
  } as const;

  return (
    <span
      className={`inline-flex items-center gap-2 rounded-full px-3 py-1 text-sm font-medium ring-1 ${toneMap[tone]}`}
    >
      <span className="text-xs opacity-80">{label}</span>
      <span>£{value.toFixed(2)}</span>
    </span>
  );
}